const roles = {
  PRODUCTOR:"Productor", 
  RRPP:"Rrpp", 
  REDIMIDOR:"Redimidor", 
  DEFAULT:"Default", 
  ADMIN:"Admin", 
  SUPERADMIN:"SuperAdmin"
}

module.exports = roles


// WEBPACK FOOTER //
// ./src/config/RolesConstants.js